import request from '@/utils/request.js';

/**
 * 新增标注工单
 * @param {Object} data 工单数据
 * @returns {AxiosPromise} Axios 请求对象
 */
export const ImgUpload = (data) =>
    request({
        url: '/data/eventInfo/upload',
        method: 'post',
        data,
    });

/**
 * 查询标注工单列表
 * @param {Object} [query] 查询参数
 * @returns {AxiosPromise} Axios 请求对象
 */
export const listEventMark = (query) =>
    request({
        url: '/data/eventMark/list',
        method: 'get',
        params: query,
    });

/**
 * 查询标注工单详细
 * @param {string|number} id 工单ID
 * @returns {AxiosPromise} Axios 请求对象
 */
export const getEventMark = (id) =>
    request({
        url: `/data/eventMark/${id}`,
        method: 'get',
    });

/**
 * 新增标注工单
 * @param {Object} data 工单数据
 * @returns {AxiosPromise} Axios 请求对象
 */
export const addEventMark = (data) =>
    request({
        url: '/data/eventMark',
        method: 'post',
        data,
    });

/**
 * 修改标注工单
 * @param {Object} data 工单数据
 * @returns {AxiosPromise} Axios 请求对象
 */
export const updateEventMark = (data) =>
    request({
        url: '/data/eventMark',
        method: 'put',
        data,
    });

/**
 * 删除标注工单
 * @param {string|number|Array} id 工单ID或ID数组
 * @returns {AxiosPromise} Axios 请求对象
 */
export const delEventMark = (id) =>
    request({
        url: `/data/eventMark/${id}`,
        method: 'delete',
    });

/**
 * 新增标注工单
 * @param {Object} data 工单任务数据
 * @returns {AxiosPromise} Axios 请求对象
 */
export const addMarkData = (data) =>
    request({
        url: '/data/eventMark/addMarkData',
        method: 'post',
        data,
    });

/**
 * 删除标注事件
 * @param {Object|Array} id 事件ID或ID数组
 * @returns {AxiosPromise} Axios 请求对象
 */
export const delMarkEvent = (id) =>
    request({
        url: `/data/eventMark/delMarkEvent?id=${id}`,
        method: 'post',
    });

/**
 * 查询事件类型详细
 * @param id
 */
export const getEventTypeTree = () =>
    request({
        url: '/data/eventType/tree',
        method: 'get',
    });

/**
 * 查询所属地区
 *
 */
export const areaTree = () => request({
    url: '/system/area/tree',
    method: 'get',
});
/**
 * 获取坐标对应的地址信息
 *
 */
export const getAddress = (query) => request({
    url: '/map/getAddress',
    method: 'get',
    params: query,
});

/**
 * 查询地图配置列表
 * @param query
 * @returns {*}
 */

export const listMapconfig = () => request({
    url: '/map/mapconfig/get',
    method: 'get',
});

/**
 * 修改地图配置
 * @param data
 */
export const getDefault = () => request({
    url: '/map//bglayer/getDefault',
    method: 'get',
});

/**
 * 查询部门下拉树结构
 */
export const deptTreeSelect = () => request({
    url: '/system/user/deptTree',
    method: 'get',
});
